import React from 'react'
import { connect } from 'react-redux'

import { RootState } from 'typedRedux/configureStoreWithHistory'
import { hideAuthModal, clearReferredBy } from 'actions/authActions'
import Modal from '../Modal'

interface AuthModalProps {
  auth: RootState['auth']
  dispatch: (arg0: object) => any
}

const AuthModal = ({ auth, dispatch }: AuthModalProps) => {
  const handleClose = () => {
    dispatch(clearReferredBy())
    dispatch(hideAuthModal())
  }

  return (
    <Modal
      onClose={handleClose}
      initialRoute="signup"
      open={auth.showAuthModal}
      referredById={auth.referredById}
      referralType={auth.referralType}
    />
  )
}

export default connect(({ auth }: { auth: RootState['auth'] }) => ({ auth }))(
  AuthModal
)
